/*
 * File: \packages\config.js
 * File Created: 2022-03-31 10:20:23
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-06-23 20:24:50
 * Modified By: Ocean Li ���
 */
export default {
  identify: "midea-connect-cli",
  globalName: "mx",
  aliasName: "Meixin",
  cordovaPath: "./cordova.js",
  cordovaTempPath: "./temp-cordova.js",
  cordovaImportLockName: "mx_cordovaLock",
  cordovaInstance: "mx_cordovaInstance",
  cordovaReady: "mx_cordovaReady",
  eventObjName: "mx_enventManager",
  errorPreffix: "***********mx cli 报错***********",
  warnPreffix: "***********mx cli 警告***********",
  infoPreffix: "mx-cli info: ",
  errorCode: {
    1000: "global mx generate fail-arguments must be array",
    1001: "global mx generate fail-argument error",
    1002: "global mx generate init fail-the config argument is illegal",
    2002: "native install error: ",
    2003: "native load error",
    9000: "triger event is null"
  },
};